import Spinner from "../Spinner";
import { Navigate } from "react-router-dom";

export default function RecordingModeGate({
  allowed,
  children,
  loading = false,
  redirectTo = "/home",
}) {
  // Distinguish "still resolving backend-driven access" from a real deny so
  // direct recording-route visits do not bounce users away during startup.
  if (loading) {
    return (
      <div
        className="w-full min-h-52 flex flex-col items-center justify-center gap-3"
        role="status"
        aria-live="polite"
      >
        <Spinner />
      </div>
    );
  }

  if (!allowed) {
    return <Navigate to={redirectTo} replace />;
  }
  return children;
}
